module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What am "), _c('i', [_vm._v("I")]), _vm._v(" to you, that you should command me to love you and, if I do not,")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("you should be angry with me and threaten great miseries?")]), _vm._v(" "), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("Augustine, "), _c('i', [_vm._v("Confessions")]), _vm._v(", I, 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "bl"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3037a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/pre5.vue
// module id = 75
// module chunks = 0